import store from '@/store/'
// eslint-disable-next-line no-unused-vars
export default function inviteUsers({ from, next, router, to }) {
  const userType = store.getters['user/type']

  // redirect to dashboard if unauthorized
  if (
    userType &&
    [
      'enterprise',
      'agency',
      'employee',
      'traffic-manager',
      'agency-client',
      'publisher',
      'brand-admin',
      // 'agency-client',
      'brand-employee',
      'agency-employee',
    ].indexOf(userType) < 0
  ) {
    return router.push({ name: 'dashboard' })
  }

  // OR do nothing and go next
  return next()
}
